import type { Components, Theme } from "@mui/material";

declare module "@mui/material/TextField" {
  interface TextFieldPropsColorOverrides {
    cyan: true;
    green: true;
    yellow: true;
    orange: true;
    magenta: true;
    purple: true;
    dark: true;
  }
}

export const covestroMuiTextField: Components<Theme>["MuiTextField"] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      "& .MuiInputBase-root .MuiInputBase-input.Mui-disabled": {
        background: theme.palette.grey["100"],
        color: theme.palette.grey["800"],
        WebkitTextFillColor: theme.palette.grey["800"],
      },
    }),
  },
};
